import React from 'react';
import { motion } from 'framer-motion';
import Navbar from './Navbar';
import Footer from './Footer';
import { useSwipeNavigation } from '../hooks/useSwipeGesture';

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit:    { opacity: 0 },
};

const pageTransition = {
  type: 'tween',
  ease: [0.22, 1, 0.36, 1],
  duration: 0.2,
};

function SwipeNavigationWrapper() {
  useSwipeNavigation();
  return null;
}

/**
 * PageLayout — wraps every page with:
 * - Sticky footer (flex col min-h-screen)
 * - Page entrance animation
 * - Mobile swipe-back gesture
 */
export default function PageLayout({ children, className = '', noFooter = false }) {
  return (
    <div className={`flex flex-col min-h-screen bg-background ${className}`}>
      <SwipeNavigationWrapper />
      <Navbar />
      <motion.main
        className="flex-1"
        variants={pageVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={pageTransition}
      >
        {children}
      </motion.main>
      {!noFooter && <Footer />}
    </div>
  );
}
